<template>
    <v-container fluid class="bg fill-height">
        <v-layout row wrap fill-height>
            <v-flex xs-12 secondary--text>
                <h1 class="display-1 font-weight-light ">
                    Loading &nbsp;<v-progress-circular :width="2" :size="24" indeterminate />
                </h1>
                <p>Please wait a moment...</p>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    data(){
        return{
            //
        }
    }
}
</script>
<style scoped>
.fill-height{ /*fill vieport height */
    height:calc(100vh - 48px - 36px);
}
.bg{
    background-color: var(--v-accent-darken3)
}
</style>